import i18n from "@/i18n/config";

let pending: Promise<void> | null = null;

/**
 * Lazily fetches and registers the Email AI feature's translation keys
 * ("email", "emailObserver", "emailTester") into the default i18next
 * namespace. Kept out of the eager i18n/config.ts bundle so this copy,
 * across 6 languages, does not ship in the main entry chunk for visitors
 * who never open Email AI. Idempotent and cached.
 */
export function ensureEmailAiLocaleLoaded(): Promise<void> {
  if (!pending) {
    pending = Promise.all([
      import("./locales/email-ai/en.json"),
      import("./locales/email-ai/es.json"),
      import("./locales/email-ai/fr.json"),
      import("./locales/email-ai/hi.json"),
      import("./locales/email-ai/pa.json"),
      import("./locales/email-ai/ur.json"),
    ]).then(([en, es, fr, hi, pa, ur]) => {
      i18n.addResourceBundle("en", "translation", en.default, true, true);
      i18n.addResourceBundle("es", "translation", es.default, true, true);
      i18n.addResourceBundle("fr", "translation", fr.default, true, true);
      i18n.addResourceBundle("hi", "translation", hi.default, true, true);
      i18n.addResourceBundle("pa", "translation", pa.default, true, true);
      i18n.addResourceBundle("ur", "translation", ur.default, true, true);
    });
  }
  return pending;
}
